module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAALdJREFUGBljZEAD/RMnpjH8Z0zn4mR3Sk9P/4gszYTMAbP/Mzr8Z/hv9O3PH0V0OUzF6CqQ+CxIbKzMqVOnqvz886eRjZm5kaDiX3/+uDP8Z4j69ff/KZKcwQT0/cz+iZOWYHUDmiDQGYw+QDE+NHGsXKDi/1+BMsxwWUaGr0A3MrAxMHwBizEyAvn/GZj+M3xhYWZkDGBkZIQr5uJgr/z58+eS7OzsOyDF0hISy54/f/WYkfHfEQAg/jaFy7Ch8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/actual-icon.png
// module id = RrV3
// module chunks = 3